// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background: hsl(0 0% 100%);
  --foreground: hsl(222.2 47.4% 11.2%);
  --muted: hsl(210 40% 96.1%);
  --muted-foreground: hsl(215.4 16.3% 46.9%);
  --popover: hsl(0 0% 100%);
  --popover-foreground: hsl(222.2 47.4% 11.2%);
  --card: hsl(0 0% 100%);
  --card-foreground: hsl(222.2 47.4% 11.2%);
  --border: hsl(214.3 31.8% 91.4%);
  --input: hsl(214.3 31.8% 91.4%);
  --primary: hsl(222.2 47.4% 11.2%);
  --primary-foreground: hsl(210 40% 98%);
  --secondary: hsl(210 40% 96.1%);
  --secondary-foreground: hsl(222.2 47.4% 11.2%);
  --accent: hsl(210 40% 96.1%);
  --accent-foreground: hsl(222.2 47.4% 11.2%);
  --destructive: hsl(0 100% 50%);
  --destructive-foreground: hsl(210 40% 98%);
  --ring: hsl(215 20.2% 65.1%);
  --radius: 0.5rem;
}

.dark {
  --background: hsl(224 71% 4%);
  --foreground: hsl(213 31% 91%);
  --muted: hsl(223 47% 11%);
  --muted-foreground: hsl(215.4 16.3% 56.9%);
  --popover: hsl(224 71% 4%);
  --popover-foreground: hsl(215 20.2% 65.1%);
  --card: hsl(224 71% 4%);
  --card-foreground: hsl(213 31% 91%);
  --border: hsl(216 34% 17%);
  --input: hsl(216 34% 17%);
  --primary: hsl(210 40% 98%);
  --primary-foreground: hsl(222.2 47.4% 1.2%);
  --secondary: hsl(222.2 47.4% 11.2%);
  --secondary-foreground: hsl(210 40% 98%);
  --accent: hsl(216 34% 17%);
  --accent-foreground: hsl(210 40% 98%);
  --destructive: hsl(0 63% 31%);
  --destructive-foreground: hsl(210 40% 98%);
  --ring: hsl(216 34% 17%);
  --radius: 0.5rem;
}

[data-theme="dark"] {
  --background: #0a0a0a;
  --foreground: #fafafa;
  --card: #1a1a1a;
  --card-foreground: #fafafa;
  --popover: #1a1a1a;
  --popover-foreground: #fafafa;
  --primary: #fafafa;
  --primary-foreground: #0a0a0a;
  --secondary: #2a2a2a;
  --secondary-foreground: #fafafa;
  --muted: #1e1e1e;
  --muted-foreground: #a1a1aa;
  --accent: #6b7280;
  --accent-foreground: #ffffff;
  --destructive: #ef4444;
  --destructive-foreground: #ffffff;
  --border: #333333;
  --input: #333333;
  --ring: #6b7280;
}

[data-theme="light"] {
  --background: #ffffff;
  --foreground: #0a0a0a;
  --card: #ffffff;
  --card-foreground: #0a0a0a;
  --popover: #ffffff;
  --popover-foreground: #0a0a0a;
  --primary: #0a0a0a;
  --primary-foreground: #ffffff;
  --secondary: #f5f5f5;
  --secondary-foreground: #0a0a0a;
  --muted: #f5f5f5;
  --muted-foreground: #737373;
  --accent: #6b7280;
  --accent-foreground: #ffffff;
  --destructive: #ef4444;
  --destructive-foreground: #ffffff;
  --border: #e5e5e5;
  --input: #e5e5e5;
  --ring: #6b7280;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: var(--background);
  color: var(--foreground);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
  transition: background-color 0.3s ease, color 0.3s ease;
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

html,
body,
#root {
  height: 100%;
  overflow: hidden;
}

.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 44px;
  height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--foreground);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.theme-toggle::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.theme-toggle:hover::before {
  left: 100%;
}

.theme-toggle:hover {
  background: #24292e;
  border-color: #24292e;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);
}

.github-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 44px;
  height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--foreground);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.github-link::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.github-link:hover::before {
  left: 100%;
}

.github-link:hover {
  background: #24292e;
  border-color: #24292e;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;EACtB,yCAAyC;EACzC,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;EACtC,+BAA+B;EAC/B,8CAA8C;EAC9C,4BAA4B;EAC5B,2CAA2C;EAC3C,8BAA8B;EAC9B,0CAA0C;EAC1C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;EAC1B,0CAA0C;EAC1C,uBAAuB;EACvB,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC;EACnC,wCAAwC;EACxC,0BAA0B;EAC1B,qCAAqC;EACrC,6BAA6B;EAC7B,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB;cACY;EACZ,uDAAuD;EACvD,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[":root {\n  --background: hsl(0 0% 100%);\n  --foreground: hsl(222.2 47.4% 11.2%);\n  --muted: hsl(210 40% 96.1%);\n  --muted-foreground: hsl(215.4 16.3% 46.9%);\n  --popover: hsl(0 0% 100%);\n  --popover-foreground: hsl(222.2 47.4% 11.2%);\n  --card: hsl(0 0% 100%);\n  --card-foreground: hsl(222.2 47.4% 11.2%);\n  --border: hsl(214.3 31.8% 91.4%);\n  --input: hsl(214.3 31.8% 91.4%);\n  --primary: hsl(222.2 47.4% 11.2%);\n  --primary-foreground: hsl(210 40% 98%);\n  --secondary: hsl(210 40% 96.1%);\n  --secondary-foreground: hsl(222.2 47.4% 11.2%);\n  --accent: hsl(210 40% 96.1%);\n  --accent-foreground: hsl(222.2 47.4% 11.2%);\n  --destructive: hsl(0 100% 50%);\n  --destructive-foreground: hsl(210 40% 98%);\n  --ring: hsl(215 20.2% 65.1%);\n  --radius: 0.5rem;\n}\n\n.dark {\n  --background: hsl(224 71% 4%);\n  --foreground: hsl(213 31% 91%);\n  --muted: hsl(223 47% 11%);\n  --muted-foreground: hsl(215.4 16.3% 56.9%);\n  --popover: hsl(224 71% 4%);\n  --popover-foreground: hsl(215 20.2% 65.1%);\n  --card: hsl(224 71% 4%);\n  --card-foreground: hsl(213 31% 91%);\n  --border: hsl(216 34% 17%);\n  --input: hsl(216 34% 17%);\n  --primary: hsl(210 40% 98%);\n  --primary-foreground: hsl(222.2 47.4% 1.2%);\n  --secondary: hsl(222.2 47.4% 11.2%);\n  --secondary-foreground: hsl(210 40% 98%);\n  --accent: hsl(216 34% 17%);\n  --accent-foreground: hsl(210 40% 98%);\n  --destructive: hsl(0 63% 31%);\n  --destructive-foreground: hsl(210 40% 98%);\n  --ring: hsl(216 34% 17%);\n  --radius: 0.5rem;\n}\n\n[data-theme=\"dark\"] {\n  --background: #0a0a0a;\n  --foreground: #fafafa;\n  --card: #1a1a1a;\n  --card-foreground: #fafafa;\n  --popover: #1a1a1a;\n  --popover-foreground: #fafafa;\n  --primary: #fafafa;\n  --primary-foreground: #0a0a0a;\n  --secondary: #2a2a2a;\n  --secondary-foreground: #fafafa;\n  --muted: #1e1e1e;\n  --muted-foreground: #a1a1aa;\n  --accent: #6b7280;\n  --accent-foreground: #ffffff;\n  --destructive: #ef4444;\n  --destructive-foreground: #ffffff;\n  --border: #333333;\n  --input: #333333;\n  --ring: #6b7280;\n}\n\n[data-theme=\"light\"] {\n  --background: #ffffff;\n  --foreground: #0a0a0a;\n  --card: #ffffff;\n  --card-foreground: #0a0a0a;\n  --popover: #ffffff;\n  --popover-foreground: #0a0a0a;\n  --primary: #0a0a0a;\n  --primary-foreground: #ffffff;\n  --secondary: #f5f5f5;\n  --secondary-foreground: #0a0a0a;\n  --muted: #f5f5f5;\n  --muted-foreground: #737373;\n  --accent: #6b7280;\n  --accent-foreground: #ffffff;\n  --destructive: #ef4444;\n  --destructive-foreground: #ffffff;\n  --border: #e5e5e5;\n  --input: #e5e5e5;\n  --ring: #6b7280;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: var(--background);\n  color: var(--foreground);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n    sans-serif;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  overflow: hidden;\n}\n\n.theme-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 44px;\n  height: 44px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--card);\n  color: var(--foreground);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.theme-toggle::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.1),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.theme-toggle:hover::before {\n  left: 100%;\n}\n\n.theme-toggle:hover {\n  background: #24292e;\n  border-color: #24292e;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);\n}\n\n.github-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 44px;\n  height: 44px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--card);\n  color: var(--foreground);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.github-link::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.1),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.github-link:hover::before {\n  left: 100%;\n}\n\n.github-link:hover {\n  background: #24292e;\n  border-color: #24292e;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(36, 41, 46, 0.3);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
